import Cookies from 'js-cookie'
import Config from '@/utils/globalSettings'

const TokenKey = Config.TokenKey
console.log('TokenKey', TokenKey)
export function getToken () {
  return Cookies.get(TokenKey, { domain: Config.tokenDomain })
}

export function setToken (token, rememberMe) {
  if (!rememberMe) {
    return Cookies.set(TokenKey, token)
  } else return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js